export default __webpack_public_path__ + "a4108cfc68768406865306fc27c68903.png";